import React from "react";

const ConfirmModal = ({
    open,
    title,
    message,
    onConfirm,
    onClose,
    confirm,
    cancel,
    danger,
}) => {
    if (!open) return null;
    return (
        <div className="confirm-modal-overlay" onClick={onClose}>
            <div
                className="confirm-modal-container"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="confirm-modal-title">{title}</div>
                <div className="confirm-modal-message">{message}</div>
                <div className="confirm-modal-actions">
                    <button
                        className="confirm-modal-btn-cancel"
                        onClick={onClose}
                    >
                        {cancel}
                    </button>
                    <button
                        className={`confirm-modal-btn-confirm ${danger ? "confirm-danger" : ""}`}
                        onClick={onConfirm}
                    >
                        {confirm}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
